/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import {
  FieldValues, Path, UseFormReturn, useFieldArray,
} from 'react-hook-form';
import { CONTRIBUTION_PERIODICITY_OPTIONS } from './options';

interface Props<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
  addLabel: string;
  emptyLabel: string;
}

export function ContributionListField<T extends FieldValues>({
  form, name, addLabel, emptyLabel,
}: Props<T>) {
  const { control, register } = form;
  const { fields, append, remove } = useFieldArray({ control, name: name as never });

  return (
    <div className="border rounded p-2">
      {fields.length === 0 && (
        <p className="text-muted small mb-2">{emptyLabel}</p>
      )}

      {fields.map((field, index) => (
        <div key={field.id} className="row g-2 align-items-end mb-2">
          <div className="col-md-3">
            <label className="form-label small mb-1">Monto (UF)</label>
            <input
              type="number"
              step="any"
              className="form-control form-control-sm"
              onWheel={(e) => e.currentTarget.blur()}
              {...register(`${name}.${index}.amount` as Path<T>)}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label small mb-1">Periodicidad</label>
            <select
              className="form-select form-select-sm"
              {...register(`${name}.${index}.periodicity` as Path<T>)}
            >
              {CONTRIBUTION_PERIODICITY_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label small mb-1">Mes de inicio</label>
            <input
              type="number"
              step="1"
              className="form-control form-control-sm"
              onWheel={(e) => e.currentTarget.blur()}
              {...register(`${name}.${index}.start_month` as Path<T>)}
            />
          </div>
          <div className="col-md-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => remove(index)}
            >
              Quitar
            </button>
          </div>
        </div>
      ))}

      <button
        type="button"
        className="btn btn-sm btn-outline-primary"
        onClick={() => append({ amount: 0, periodicity: 'monthly', start_month: 1 } as never)}
      >
        {addLabel}
      </button>
    </div>
  );
}
